import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Loader from "../../components/Loader/Loader";
import Page from "../../components/Page";
import PrivacyandTermsSection from "../../components/Privacy/PrivacyandTermsSection";
import { loginClear } from "../../redux/auth/actions";
import { SessionKeys } from "../../utils/AppUtils";
const PrivacyandTerms = () => {

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const auth = useSelector((state) => state.auth);
  const [isLoading, setIsLoading] = useState(false)
  useEffect(() => {
    if (document.getElementById("id_page_404") !== null) {
      document.getElementById("id_page_404").style.display = "none";
    }
  }, [])
  useEffect(() => {
    //console.log("token", SessionKeys.API_TOKEN_BROKER);
    if (Object.entries(auth.authBroker).length > 0) {
      const authData = auth.authBroker;
      //  console.log("authData", authData);
      if (!authData.payload.apiToken) {
        localStorage.removeItem(SessionKeys.API_TOKEN_BROKER);
        dispatch(loginClear());
        navigate("/", { relogin: true });
      }
    } else if (!localStorage.getItem(SessionKeys.API_TOKEN_BROKER)) {
      dispatch(loginClear());
      navigate("/", { relogin: true });
    }
  }, []);

  return (
    <>
      <Loader start={isLoading} />

      <PrivacyandTermsSection
        setIsLoading={setIsLoading}
      />
    </>
  )
}

export default PrivacyandTerms